import { FileText, ClipboardCheck } from 'lucide-react';

/**
 * Tab bar for split-screen verification modals on mobile.
 * Renders two primary-level pill tabs (Document | Form) using the
 * canonical tab-btn / tab-btn-admin CSS classes from the design system.
 *
 * Only rendered when isMobile is true — desktop keeps the side-by-side layout.
 * The parent modal owns activeTab state and passes it here as a controlled prop.
 */
const MobileVerificationTabs = ({
  activeTab,
  onTabChange,
  documentLabel = 'Document',
  formLabel = 'Verification',
  isAdmin = false,
}) => {
  const btnClass = isAdmin ? 'tab-btn-admin' : 'tab-btn';

  return (
    <div className="grid grid-cols-2 gap-2 px-4 py-2 border-b border-gray-200 bg-white flex-shrink-0">
      <button
        type="button"
        onClick={() => onTabChange('document')}
        className={`${btnClass} ${activeTab === 'document' ? 'active' : ''} w-full justify-center`}
      >
        <FileText className="w-4 h-4" />
        {documentLabel}
      </button>
      <button
        type="button"
        onClick={() => onTabChange('form')}
        className={`${btnClass} ${activeTab === 'form' ? 'active' : ''} w-full justify-center`}
      >
        <ClipboardCheck className="w-4 h-4" />
        {formLabel}
      </button>
    </div>
  );
};

export default MobileVerificationTabs;
